import { getProhibitionLengthCounts } from './getProhibitionLengthCounts';

export const getProhibitionLengthLabel = (
	length: string | undefined,
	t: (
		key: string,
		values?: Record<string, string | number> | undefined
	) => string,
	emptyFallback: string
): string => {
	const { monthsCount, daysCount } = getProhibitionLengthCounts(length);

	const parts = [
		monthsCount > 0 ? t('data.delka-mesice', { count: monthsCount }) : null,
		daysCount > 0 ? t('data.delka-dny', { count: daysCount }) : null,
	].filter(Boolean);

	if (parts.length > 0) {
		return parts.join(' ');
	}

	return length?.trim() || emptyFallback;
};
